import PropTypes from 'prop-types';
import React from 'react';
import { PasswordRulesMessages as messages } from './PasswordRulesHint.i18n';

export class PasswordRulesHint extends React.Component {
  render() {
    if (!this.props.rules) {
      return null;
    }
    const { minLength, capitalLetters, numbers, specialCharacters } = this.props.rules;
    const { formatMessage } = this.props.intl;
    const description = formatMessage(messages.rules.description);
    const minLengthText = formatMessage(messages.rules.minLength, { minLength });
    const capitalLettersText = formatMessage(messages.rules.capitalLetters, { capitalLetters });
    const numbersText = formatMessage(messages.rules.numbers, { numbers });
    const specialCharactersText = formatMessage(messages.rules.specialCharacters, { specialCharacters });
    let delimitedList = '';
    if (minLength > 0) {
      delimitedList += minLengthText;
    }
    if (capitalLetters > 0) {
      delimitedList += capitalLettersText;
    }
    if (numbers > 0) {
      delimitedList += numbersText;
    }
    if (specialCharacters > 0) {
      delimitedList += specialCharactersText;
    }
    const passwordRulesFormat = formatMessage(messages.rules.format, { description, delimitedList });
    return (
      <div id="hlp_password">
        {passwordRulesFormat}
      </div>);
  }
}

PasswordRulesHint.propTypes = {
  rules: PropTypes.object,
  intl: PropTypes.object.isRequired,
};

export default PasswordRulesHint = PasswordRulesHint;